<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'templateSortDialog',
})
</script>
<template>
  <ant-Modal v-model:open="state.dialog.visible" transition-name="" :centered="true" :maskClosable="false"
    :closable="false" :keyboard="false" :title="state.dialog.title" :width="state.dialog.width"
    :confirm-loading="state.loading.submit" :ok-text="state.dialog.submitTxt" @ok="onSubmit" @cancel="closeDialog">
    <div class="form-content">
      <a-form :model="state" :wrapper-col="{ style: 'flex: 1' }">
        <a-form-item label="分类" name="categoryCode">
          <a-select v-model:value="state.categoryCode" placeholder="请选择分类" allow-clear :disabled="state.loading.list"
            @change="onCategoryChange">
            <a-select-option v-for="item in categoryList" :key="item.code" :value="item.code">{{ item.name
              }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
      <div class="table-scroll-wrapper">
        <template v-if="state.dialog.visible">
          <VueDraggable v-if="tableData.length > 0" v-model="tableData" target=".ant-table-tbody" handle=".sort-handle"
            :animation="150" :scroll="true" :scroll-sensitivity="30" :disabled="state.loading.list">
            <a-table :columns="columns" :data-source="tableData" :pagination="false" size="small" row-key="id">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'sortOrder'">
                  <div class="sort-handle" style="cursor: move;">
                    <MenuOutlined />
                  </div>
                </template>
                <template v-else-if="column.key === 'createTime'">
                  {{ record.createTime || '-' }}
                </template>
              </template>
            </a-table>
          </VueDraggable>
          <a-table v-else :columns="columns" :data-source="[]" :pagination="false" size="small"
            :loading="state.loading.list" />
        </template>
      </div>
    </div>
  </ant-Modal>
</template>

<script setup lang="ts" name="templateSortDialog">
import { reactive, ref, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import { VueDraggable } from 'vue-draggable-plus'
import { MenuOutlined } from '@ant-design/icons-vue'
import { useMaterial } from '@/store/material/material'

const materialStore = useMaterial()

const emit = defineEmits(['refresh'])

const props = defineProps<{
  categoryList: any[]
}>()

const columns = [
  { title: '排序', key: 'sortOrder', width: 100 },
  { title: '模板名称', dataIndex: 'materialName', key: 'materialName', ellipsis: true },
  { title: '上传时间', key: 'createTime', width: 180 }
]

const tableData = ref<any[]>([])

const state = reactive({
  dialog: {
    visible: false,
    title: '小程序展示排序',
    submitTxt: '保存',
    width: '800px'
  },
  loading: {
    submit: false,
    list: false
  },
  categoryCode: '' as string
})

const fetchList = async () => {
  if (!state.categoryCode) {
    tableData.value = []
    return
  }
  state.loading.list = true
  try {
    const data: any = await materialStore.getMaterialList({ categoryCode: state.categoryCode })
    tableData.value = (data || []).map((item: any) => ({
      ...item,
      id: String(item.id)
    }))
  } catch {
    tableData.value = []
  } finally {
    state.loading.list = false
  }
}

const onCategoryChange = () => {
  fetchList()
}

const openDialog = () => {
  const firstCategory = props.categoryList?.[0]
  state.categoryCode = firstCategory?.code || ''
  state.dialog.visible = true
  nextTick(() => {
    fetchList()
  })
}

const onSubmit = async () => {
  try {
    state.loading.submit = true
    const sortList = tableData.value.map((item: any, index: number) => ({
      id: item.id,
      sortOrder: index + 1
    }))
    await materialStore.batchSortMaterial(sortList)
    message.success('排序保存成功')
    state.loading.submit = false
    emit('refresh')
    closeDialog()
  } catch {
    state.loading.submit = false
  }
}

const closeDialog = () => {
  state.loading.submit = false
  state.loading.list = false
  state.dialog.visible = false
  state.categoryCode = ''
  tableData.value = []
}

defineExpose({
  openDialog,
  closeDialog
})
</script>

<style scoped lang="less">
.form-content {
  padding: 40px 35px 32px 35px;
}

// ===== 表单 =====
:deep(.ant-form-item) {
  margin-bottom: 0px;
  padding-bottom: 24px;
}

:deep(.ant-form-item-label) {
  margin-left: 0px;
  margin-right: 5px;
  width: 50px;
  text-align: right;
  justify-content: flex-end;
  display: flex;
  align-items: center;
  height: 40px;
}


:deep(.ant-input-disabled) {
  height: 40px;
  border-color: #C5C5D3;
  border-radius: 4px;
}

:deep(.ant-select-selector) {
  height: 40px !important;
  display: flex;
  align-items: center;
  border-radius: 4px;
}


// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-input-affix-wrapper:not(:hover):not(.ant-input-affix-wrapper-focused)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-select:not(.ant-select-disabled):not(.ant-select-focused) .ant-select-selector:not(:hover)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(textarea.ant-input:not(:hover):not(:focus)) {
  border-color: #C5C5D3;
}

.sort-handle {
  display: flex;
  align-items: center;
}

.table-scroll-wrapper {
  max-height: 50vh;
  overflow-y: auto;
}
</style>
